import { render, staticRenderFns } from "./ConfigModal.vue?vue&type=template&id=c6e0d96e&scoped=true"
import script from "./ConfigModal.vue?vue&type=script&lang=js"
export * from "./ConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e0d96e",
  null
  
)

export default component.exports